import React, {Component} from 'react';
import {connect} from 'react-redux';
import {message} from 'antd';

import Admin from './Admin';
import {
    storeAdmin,
    updateAdmin,
    fetchAdmins,
    fetchBranches
} from '../../actions';

class AdminContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverErrors: null
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {admin} = nextProps;
        if (!admin) return null;

        if (admin.error) {
            return {serverErrors: admin.error}
        }
        if (!admin.error && prevState.serverErrors) {
            return {serverErrors: null}
        }
        return null;
    }
    static notifySuccess() {
        message.success('Successfully updated');
    }
    static notifyError(errors) {
        const errs = typeof errors === 'string' ? errors : Object.keys(errors).map(key => errors[key].map((e, i) => <span key={i}>{e}</span>));
        message.error(errs);
    }
    handlePostSubmit() {
        const {state: {serverErrors}, props: {history}} = this;
        if (!serverErrors) {
            AdminContainer.notifySuccess();
            setTimeout(() => history.goBack(), 100);
            return;
        }

        const {res: {errors, message}} = serverErrors;
        AdminContainer.notifyError(errors || message);
    }
    componentDidMount() {
        const {
            match: {params: {admin: id}},
            landlord,
            fetchAdmins,
            fetchBranches,
            admin,
            branches
        } = this.props;
        !branches.data.length && fetchBranches(landlord);

        if (!id) return;
        !admin && fetchAdmins(landlord);
    }
    render() {
        const {storeAdmin, updateAdmin, landlord, history, admin, branches} = this.props;
        const onSubmit = (values) => {
            const fn = !admin || admin.draft ? storeAdmin : updateAdmin;
            const args = !admin || admin.draft ? [landlord, values] : [landlord, admin.id, {...values, id: admin.id}];
            return fn(...args).then(() => this.handlePostSubmit(values));
        };

        return <Admin admin={admin} branches={branches} onSubmit={onSubmit} onCancel={() => history.goBack()}/>;
    }
}

const mapStateToProps = (state, ownProps) => {
    // id exists for edit component
    const {match: {params: {admin: id}}} = ownProps;
    const admin = state.landlord.admins.data.find(b => id ? (b.id === +id) : b.draft);
    return {
        landlord: state.me.application.id,
        branches: state.landlord.branches,
        admin
    };
};
export default connect(mapStateToProps, {
    storeAdmin,
    updateAdmin,
    fetchAdmins,
    fetchBranches
})(AdminContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/AdminContainer.js